import * as tslib_1 from "tslib";
import { observable } from "mobx";
/**
 * QAEventInfo defines QA market/event.
 *
 * @typedef QAEventInfo
 * @type {Object}
 * @property {id} Unique identifier
 * @property {name} Name of the event
 * @property {typeId} type of the event (RaceCard,TrapMarket etc.)
 * @property {date} Date of event
 * @property {lines} Hashtable of QALines
 * @property {branchId} brachId for the event
 * @property {leagueId} Id of the league
 * @property {leagueName} Name of the league
 * @property {link} used for SEO navigation
 */
var QAEventInfo = /** @class */ (function () {
    function QAEventInfo(source) {
        this.id = source.id;
        this.typeId = source.typeId;
        this.branchId = source.branchId;
        this.leagueName = source.leagueName;
        this.leagueId = source.leagueId;
        this.lines = source.lines;
        this.date = source.date;
        this.typeName = source.typeName;
        this.name = source.name;
        this.link = source.link;
        this.isDanger = source.isDanger;
    }
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", Array)
    ], QAEventInfo.prototype, "lines", void 0);
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", Boolean)
    ], QAEventInfo.prototype, "isDanger", void 0);
    return QAEventInfo;
}());
export { QAEventInfo };
//# sourceMappingURL=QAEventInfo.js.map